import {
  faCheckCircle,
  faExclamationCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast, type ToastOptions } from 'react-toastify';

import { getFriendlyFieldMessage } from './ErrorMessageHelper';

const defaultOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  className: 'glass-toast',
};

const renderToast = (title: string, message: string, icon: any, typeClass: string) => (
  <div className={`toast-content ${typeClass}`}>
    <div className={`toast-icon ${typeClass}`}>
      <FontAwesomeIcon icon={icon} />
    </div>
    <div className="toast-text">
      <span className="toast-title">{title}</span>
      <span className="toast-message">{message}</span>
    </div>
  </div>
);

export const notify = {
  success: (message: string, title = 'Success', options?: ToastOptions) =>
    toast(renderToast(title, message, faCheckCircle, 'toast-icon-success'), {
      ...defaultOptions,
      ...options,
    }),

  // Raw field names in a message ("billing_address_details is required") are rewritten here, once,
  // so every error toast in the app reads in plain words.
  error: (message: string, title = 'Error', options?: ToastOptions) =>
    toast(
      renderToast(
        title,
        getFriendlyFieldMessage(message, message),
        faExclamationCircle,
        'toast-icon-error'
      ),
      {
        ...defaultOptions,
        ...options,
      }
    ),

  info: (message: string, title = 'Info', options?: ToastOptions) =>
    toast(renderToast(title, message, faInfoCircle, 'toast-icon-info'), {
      ...defaultOptions,
      ...options,
    }),
};
